import React, { useState, useEffect, useCallback } from 'react'
import { Modal, Form, Spinner, Alert, Button } from 'react-bootstrap'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import { t } from 'i18next'
import { getErrorMessageFromApiResponse } from '../../../utils/api/apiUtils'
import { ButtonWithLoadingState } from '../../Buttons'
import ArraySelect from '../../Select/ArraySelect'
import { emptyGuid } from '../../../utils/emptyGuid'
import useStores from '../../../stores/useStore'
import { formatedDate } from '../../../utils/formatedDate'

const performMaintananceTemplateObj = {
  comment: '',
  supplierId: emptyGuid,
}
const PerformMaintananceModal = ({ instance, handleClose }) => {
  const { inventoryStore } = useStores()
  const [formData, setFormData] = useState(performMaintananceTemplateObj)
  const [suppliers, setSuppliers] = useState([])
  const [dataIsLoading, setDataIsLoading] = useState(true)
  const [submitIsLoading, setSubmitIsLoading] = useState(false)
  const [error, setError] = useState('')
  const [, /*success*/ setSuccess] = useState(false)

  const initData = useCallback(async () => {
    setDataIsLoading(true)
    try {
      const promises = await Promise.all([loadSuppliers()])
      let resultSuppliers = promises[0]
      setSuppliers(
        resultSuppliers.filter((item) => item.isForArticleMaintenance)
      )
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    } finally {
      setDataIsLoading(false)
    }
  }, [])

  useEffect(() => {
    initData()
  }, [initData])

  async function handleSubmit() {
    setError('')
    setSuccess(false)
    setSubmitIsLoading(true)
    try {
      let lastJob = await performMaintanance()
      let lastService = formatedDate(lastJob.dateOfCreation)
      /*if (lastJob.jobNumber)
    lastService += ", " + lastJob.jobNumber*/
      if (lastJob.suppllierName) lastService += ', ' + lastJob.suppllierName
      if (lastJob.comment) lastService += ', ' + lastJob.comment
      inventoryStore.updateArticleInstanceItem(
        instance.instanceId,
        'lastService',
        lastService
      )
      setSuccess(true)
      handleClose()
    } catch (e) {
      setError(getErrorMessageFromApiResponse(e))
    } finally {
      setSubmitIsLoading(false)
    }
  }
  async function loadSuppliers() {
    return await apiClient.getJson(APIEndpoints.suppliers)
  }

  async function performMaintanance() {
    return await apiClient.postJson(
      APIEndpoints.performMaintanance(instance.instanceId),
      formData
    )
  }

  return (
    <Modal
      style={{ textAlign: 'center' }}
      centered
      show={true}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>{`${t('inventory:performMaintananceTitle')} ${
          instance.serialKey
        }`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {dataIsLoading ? (
          <div className='d-flex justify-content-center p-5'>
            <Spinner animation='border' variant='primary' />
          </div>
        ) : (
          <>
            {
              <div>
                <Form.Group className='mb-3'>
                  <Form.Label>{t('inventory:Kommentar')}</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows='3'
                    name='comment'
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        comment: e.target.value,
                      }))
                    }
                    value={formData.comment}
                  />
                </Form.Group>
                <Form.Group className='mb-3'>
                  <Form.Label>{t('inventory:externalPartner')}</Form.Label>
                  <ArraySelect
                    onChange={(supplier) =>
                      setFormData((prev) => ({
                        ...prev,
                        supplierId: supplier.id,
                      }))
                    }
                    value={formData.supplierId}
                    options={suppliers}
                    defaultOption={{
                      id: emptyGuid,
                      displayName: t('pleaseSelect'),
                    }}
                    defaultOptionIsSelectable={true}
                  />
                </Form.Group>
              </div>
            }
          </>
        )}
        {error && <Alert variant='danger'>{error}</Alert>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose}>
          {t('closeButton')}
        </Button>
        <ButtonWithLoadingState
          variant='primary'
          buttonText={t('inventory:performMaintanance')}
          isLoading={submitIsLoading}
          onClick={handleSubmit}
        />
      </Modal.Footer>
    </Modal>
  )
}

export default PerformMaintananceModal
